
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/payment",
      function () {
        return require("private-next-pages/account/payment.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/payment"])
      });
    }
  